import * as React from 'react';

import GenericInlineCta from '@lendi-jam/generic-inline-cta';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';

import { GenericInlineCtaContent } from '#contentTypes/GenericInlineCta';

interface PrismicGenericInlineCtaProps {
  component: GenericInlineCtaContent;
}

const PrismicGenericInlineCta: React.FC<PrismicGenericInlineCtaProps> = ({ component }) => {
  const {
    cta_primary_button,
    cta_primary_button_link,
    cta_secondary_button,
    cta_secondary_button_link,
    cta_heading,
    cta_body,
  } = component.primary;
  const PrimaryButton = cta_primary_button.text
    ? { text: cta_primary_button.text, url: embedMarketingTrackingIntoURL(cta_primary_button_link?.url) }
    : undefined;
  const SecondaryButton = cta_secondary_button?.text
    ? { text: cta_secondary_button.text, url: embedMarketingTrackingIntoURL(cta_secondary_button_link?.url) }
    : undefined;

  return (
    <GenericInlineCta
      title={cta_heading.text}
      body={cta_body.text}
      primaryButton={PrimaryButton}
      secondaryButton={SecondaryButton}
    />
  );
};

export default PrismicGenericInlineCta;
